import React, { useState } from 'react';
import MapEditor from '../components/MapEditor/MapEditor';
import MapDemo from '../components/MapEditor/MapDemo';

const MapEditorPage = () => {
  // const [showEditor, setShowEditor] = useState(false);

  // if (showEditor) {
  //   return <MapEditor />;
  // }

  return <MapEditor />;
};

export default MapEditorPage; 